export enum PlatformTfaMethodType {
  APP = 'app',
  KEY = 'cross-platform',
  OS = 'platform',
}
